<!-- @format -->

<div class="image-box">
	@if (!animation() && image()) {
		<picture>
			@if (mobileImageSrcset()) {
				<source [srcset]="mobileImageSrcset()" media="(max-width: 766px)" />
			}
			@if (willLazyLoad()) {
				<img
					[src]="image()?.value"
					[alt]="image()?.altText"
					class="hmf-soft-radius"
					loading="lazy" />
			} @else {
				<source
					type="image/webp"
					[srcset]="desktopImageSrcset()" />
				<img
					[src]="image()?.value"
					class="hmf-soft-radius"
					[alt]="image()?.altText"
					[attr.fetchpriority]="prioritize() ? 'high' : 'auto'" />
			}
		</picture>
	}
	@if (animation()) {
		<video
			muted
			playsinline
			controlsList="nofullscreen nodownload"
			(loadedmetadata)="$any($event.target).muted = true"
			(canplay)="$any($event.target).play()"
			[isVideo]="true"
			[attr.aria-label]="animation()?.altText"
			[poster]="$safeNavigationMigration(image()?.value)"
			[sharedUtilsDirectiveCommonLazyLoad]="animation()?.value">
			Your browser does not support the video tag.
		</video>
	}
</div>